<template>
  <div class="sumit-page">
    <div>
      <div class="minvoice">
        <van-field label="发票信息 :" value="个人 电子发票" readonly input-align="right"/>
        <!-- <van-field label="支付方式 :" value="支付宝" readonly input-align="right"/> -->
        <van-field v-model="info.name" label="姓名:" placeholder="请输入姓名" input-align="right"/>
        <van-field
          v-model="info.mobile"
          type="tel"
          label="手机号:"
          input-align="right"
          placeholder="请输入手机号"
        />
      </div>
      <div class="order-goods">
        <div class="item-left">
          <img :src="goods.photos" alt="">
        </div>
        <div class="item-right">
          <div class="item-right-title">{{goods.productName}}</div>
          <div class="item-right-price">{{goods.price | price}}</div>
          <div class="item-right-num">数量 x1</div>
        </div>
      </div>
      <div class="mpay">
        <div>应付金额: <span style="color: #A30014">{{goods.price | price}}</span></div>
        <div class="mpay-btn" @click="submitOrder">立即支付</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from 'vant';
export default {
  data() {
    return {
      info: {
        name: '',
        mobile: ''
      },
      goods: {}
    }
  },
  mounted() {
    this.goods = JSON.parse(this.$route.query.obj)
  },
  methods: {
    async submitOrder() {
      // if (this.info.name === '') {
      //   Toast('请输入姓名!');
      //   return
      // }
      // if (!/^1\d{10}$/.test(this.info.mobile)) {
      //   Toast('请输入收货人正确的手机号!');
      //   return
      // }
      let obj = {...this.info, id: this.goods.id}
      this.$router.push({name: 'offinePay', query: {obj: JSON.stringify(obj)}})
    },
    payApply(id) {
      this.$store.dispatch('payApply/apply', { orderId: id })
    }
  }
}
</script>
<style lang="less" scoped>
.sumit-page {
  .order-goods {
    margin-top: 10px;
    background-color: #fff;
    padding: 10px 10px 0 10px;
    display: flex;
    justify-content: space-around;
    .item-left {
      width: 140px;
      height: 120px;
      img {
        // width: 140px;
        height: 100%;
      }
    }
    .item-right {
      padding: 15px 15px;
      &-title {
        overflow:hidden;
        text-overflow:ellipsis;
        display:-webkit-box;
        -webkit-box-orient:vertical;
        -webkit-line-clamp:2;
        color: #555555;
      }
      &-price{
        font-size: 16px;
        color: #A30014;
        padding: 10px 0px;
      }
      &-num {
        color: #555555;
      }
    }
  }
  // .minvoice {
  //   margin-top: 10px;
  // }
  .mpay {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 60px;
    width: 100vw;
    box-shadow: 0px -1px 5px rgba(170, 170, 170, 0.35);
    background-color: #fff;
    display: flex;
    justify-content: space-around;
    align-items: center;
    .mpay-btn {
      width: 120px;
      height: 36px;
      background-color: #409EFF;
      color: #FFFFFF;
      text-align: center;
      line-height: 36px;
      border-radius: 5px;
    }
  }
}
</style>
